import { Api } from "../../common/lib/httpRequest";
import {
  LoginRequest,
  GetUserInfoResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse
} from "../utils/types";

export const apiLogin = (data: LoginRequest): Promise<GetUserInfoResponse> => {
  return Api.post(`api/v1/user/account/login`, data);
};

export const apiForgotPassword = (data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
  return Api.post(`api/v1/user/account/reset-password`, data);
};